module.exports = __webpack_public_path__ + "img/yishi1.d91cca2f.jpg";